import styled from 'styled-components';

const Box = styled.form`
  max-width: 462px;
  width: 100%;
`;

const Content = styled.div`
  padding: var(--space-16);
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
`;
const FormButton = styled.div`
  display: flex;
  gap: var(--space-12);
  align-items: flex-end;
  justify-content: flex-end;
`;

export { Box, Content, FormButton };
